import {
  IconButton as ChakraUIIconButton,
  IconButtonProps
} from "@chakra-ui/react";

interface ExtIconButtonProps extends IconButtonProps {
  // new prop added to implement destructive variant to buttons
  isDestructive?: boolean;
  isElevated?: boolean;
  [key: string]: any;
}

function IconButton(props: ExtIconButtonProps) {
  return (
    <ChakraUIIconButton
      {...props}
      boxShadow={props.isElevated ? "lg" : "none"}
      variant={
        props.isDestructive ? `destructive-${props.variant}` : props.variant
      }
      borderRadius="50%"
    />
  );
}

export { IconButton, type ExtIconButtonProps };
